import { render, staticRenderFns } from "./ModifyPage.vue?vue&type=template&id=9fb15c76&scoped=true&"
import script from "./ModifyPage.vue?vue&type=script&lang=js&"
export * from "./ModifyPage.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPage.vue?vue&type=style&index=0&id=9fb15c76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb15c76",
  null
  
)

export default component.exports